module.exports = __webpack_public_path__ + "img/figure-8.200a532b.png";